import React from 'react';
import PropTypes from 'prop-types';

/**
 * One identity provider's button on the login modal — the markup only.
 *
 * Shared so Google and Microsoft are the same shape, size and weight whether they sit alone or
 * side by side. Each provider's own component owns the awkward part (resolving a client ID,
 * opening a popup, getting a code back) and hands the mark and the label to this.
 *
 * @param {React.ReactNode} mark - the provider's logo, drawn to their branding rules
 * @param {string} label - the provider's name
 * @param {Function} onClick
 * @param {boolean} [disabled]
 * @param {string} name - short provider slug, for test and Cypress hooks
 */
const SsoButton = ({ mark, label, onClick, disabled, name }) => (
	<button
		type="button"
		className="px-auth-modal-sso-button"
		onClick={onClick}
		disabled={disabled}
		data-cy={`${name}-signin`}
		data-testid={`${name}-signin`}
	>
		{mark}
		<span>{label}</span>
	</button>
);

SsoButton.propTypes = {
	mark: PropTypes.node.isRequired,
	label: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	name: PropTypes.string.isRequired
};

export default SsoButton;
